import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

/**
 * Animated count-up component triggered on viewport entry.
 * Supports decimals (e.g. 2.4) and optional prefix/suffix.
 */
export default function CountUp({
  end,
  decimals = 0,
  duration = 1800,
  prefix = "",
  suffix = "",
  className = "",
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const startTs = performance.now();
    const target = Number(end) || 0;

    const tick = (now) => {
      const t = Math.min(1, (now - startTs) / duration);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - t, 3);
      setValue(target * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
      else setValue(target);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, end, duration]);

  const formatted = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toLocaleString();
  return (
    <span ref={ref} className={className}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
